import { render, staticRenderFns } from "./EditarPostulante.vue?vue&type=template&id=e0477a4e&scoped=true&"
import script from "./EditarPostulante.vue?vue&type=script&lang=js&"
export * from "./EditarPostulante.vue?vue&type=script&lang=js&"
import style0 from "./EditarPostulante.vue?vue&type=style&index=0&id=e0477a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0477a4e",
  null
  
)

export default component.exports